import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { FavouritesUserReplacementResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';

export const postUserReplacement = async (userId: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.PostUserReplacement);
  const authentication = await globalThis.ikea.mvAgent.authentication?.isLoggedIn();

  const response = await network.post<FavouritesUserReplacementResponse>(
    path,
    {
      userId: userId,
      userSource: 'irw',
    },
    {
      ...((authentication?.authToken ?? authentication?.guestToken) && {
        headers: {
          'x-auth-token': authentication.authToken ?? authentication.guestToken,
        },
      }),
    },
  );

  return response.data;
};
